import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {BaseComponentModel} from '@mintdata/mint-kit/api/models/BaseComponentModel';
import {ColorWithVisibility} from '@mintdata/mint-kit/api/models/ColorWithVisibility';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';
import {Overflow} from '@mintdata/mint-kit/api/models/Overflow';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';

export class ViewportModel extends BaseComponentModel
{
    @Property<ColorWithVisibility>({
        title: 'Background Color',
        tip: 'Background Color',
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: ColorWithVisibility
    })
    bg?:ColorWithVisibility;

    @Property<Overflow>({
        title: 'Horizontal overflow',
        tip: `Horizontal overflow`,
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: Overflow,
    })
    overflowX:Overflow;

    @Property<Overflow>({
        title: 'Vertical overflow',
        tip: `Vertical overflow`,
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: Overflow,
    })
    overflowY:Overflow;

    @Property<ABoolean>({
        title: 'Close on Esc',
        tip: `Close on Esc`,
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    closeOnEsc?:ABoolean;

    @Property<ABoolean>({
        title: 'Close by Click',
        tip: `Close by Click`,
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    closeByClick?:ABoolean;

    @Property<ABoolean>({
        title: 'Pass Events Through',
        tip: `Pass Events Through`,
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    passEventsThrough?:ABoolean;

    @Property<ABoolean>({
        title: 'Accelerate scroll on mobile',
        tip: 'Accelerate scroll on mobile',
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    accelerateScrollOnMobile:ABoolean;

    public constructor(bg?:ColorWithVisibility,
                       overflowX?:Overflow,
                       overflowY?:Overflow,
                       closeOnEsc?:ABoolean,
                       closeByClick?:ABoolean,
                       passEventsThrough?:ABoolean,
                       accelerateScrollOnMobile?:ABoolean)
    {
        super();

        this.bg = bg;
        this.overflowX = overflowX;
        this.overflowY = overflowY;
        this.closeOnEsc = closeOnEsc;
        this.closeByClick = closeByClick;
        this.passEventsThrough = passEventsThrough;
        this.accelerateScrollOnMobile = accelerateScrollOnMobile;
    }

    public static default():ViewportModel
    {
        return new ViewportModel(
            ColorWithVisibility.white(),
            Overflow.hidden(),
            Overflow.auto(),
            ABoolean.false(),
            ABoolean.false(),
            ABoolean.false(),
            ABoolean.false(),
        );
    }
}
